import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { AvaliacoesDataGrid } from '../../organisms';
import { BaseTemplate } from '../';

const AvaliacoesTemplate = memo(props => {
  const { initialState, state, ...restDataGridProps } = props.dataGridProps;

  return (
    <BaseTemplate
      title={props.title}
      subtitle={props.subtitle}
      description={props.description}
      scrollable={true}
      headerRenderActions={props.headerRenderActions}>
      {props.children}
      <AvaliacoesDataGrid
        {...restDataGridProps}
        initialState={{
          ...initialState,
          density: 'comfortable'
        }}
        state={state}
      />
    </BaseTemplate>
  );
});

AvaliacoesTemplate.propTypes = {
  data: PropTypes.array,
  isFetching: PropTypes.bool,
  readData: PropTypes.func,
  title: PropTypes.string,
  subtitle: PropTypes.string
};

export default AvaliacoesTemplate;
